import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

// Chip for inventory-bidder
export const ChipInventory = createChipWihFadingBackgroundVariations(
  getColorTheme('channelBidderChip'), // Channel bidder color
  getColorTheme('channelBidderChip') + '19', // Channel bidder color 10% opacity
  getColorTheme('channelBidderChip') + '0C', // Channel bidder color 5% opacity
  getColorTheme('channelBidderChip') + '26', // Channel bidder color 15% opacity
  true,
  true,
);
